'use strict';

wbApp.controller('ActivityReconciliationRecurringInvoiceDetailCtrl', ['$scope', '$filter', 'messageBoxSvc', 'invoiceRecurrenceScheduleSvc',
function ($scope, $filter, messageBoxSvc, invoiceRecurrenceScheduleSvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "activities/activity-reconciliation/recurring-invoice-detail-main-tab.html"
        },
        {
            title: 'TXT_LAB_INVOICE',
            template: "activities/activity-reconciliation/recurring-invoice-detail-invoice-tab.html"
        }
    ];

    $scope.minDate = moment($scope.model.startDate).startOf('day').subtract(1, 'day');

    $scope.detailTabs.activeTab = 0;


    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;


        if (!data.invoiceRecurrenceScheduleID) {
            invoiceRecurrenceScheduleSvc.insert(data, success, error);
        } else {
            invoiceRecurrenceScheduleSvc.update(data, success, error);
        }

        function success(model) {
            $scope.$hide();
            if (!!$scope.onScheduleSave) {
                $scope.onScheduleSave(model);
            }
        }

        function error(data) {
            $scope.detailError = data;
            $scope.isSaving = false;
        }
    }

}]);